import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeRequest } from "../../api/api";

export const postUserDetails = createAsyncThunk(
  'user/postUserDetails',
  async (payload) => {
    const request = await makeRequest("post", "v2/auth/create_user/", payload)
    const response = await request.data.data
    return response;
  }
)

export const getUserDetails = createAsyncThunk(
  'user/getUserDetails',
  async () => {
    const request = await makeRequest("get", "v2/pooling/fetch_user_list/")
    const response = await request.data.data
    return response;
  }
)

export const deleteUser = createAsyncThunk(
  'user/deleteUser',
  async (id) => {
    const request = await makeRequest("delete", `v2/auth/delete_user/${id}`)
    const response = await request.data.data
    return response;
  }
)

export const assignVessels = createAsyncThunk(
  'user/assignVessels',
  async (params) => {
    const request = await makeRequest("post", ``)
    const response = await request.data.data
    return response;
  }
)

const UserManagementSlice = createSlice({
  name: 'userDetails',
  initialState: {
    userDetails: [],
    status: 'idle',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postUserDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postUserDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(postUserDetails.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getUserDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userDetails = action.payload
        console.log(action.payload)
      })
      .addCase(getUserDetails.rejected, (state) => {
        state.status = 'failed';
      })
  },
});


export default UserManagementSlice.reducer